import React from 'react'

import Text, * as Text$ from '../Text'

export interface FieldDescriptionProps extends Text$.TextProps {}
export function FieldDescription(props: FieldDescriptionProps) {
  return <Text level={'s'} color={'secondary'} top={'0.25'} {...props} />
}
